'use client';
import type { ReactElement } from "react";
import { GANTT_STATUS_COLORS } from "./gantt-constants";
import { GanttTaskStatus } from "./gantt-types";
export interface GanttSvgDefsProps {
    ganttIdPrefix: string;
}
export function GanttSvgDefs({ ganttIdPrefix, }: GanttSvgDefsProps): ReactElement {
    return (
      <defs>
        <filter id={`${ganttIdPrefix}-barGlow`} x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur in="SourceGraphic" stdDeviation={3}/>
        </filter>
        <filter id={`${ganttIdPrefix}-todayGlow`} x="-120%" y="-120%" width="340%" height="340%">
          <feGaussianBlur in="SourceGraphic" stdDeviation={2}/>
        </filter>

        {Object.values(GanttTaskStatus).map((status) => {
            const color = GANTT_STATUS_COLORS[status];
            const gradientId = `${ganttIdPrefix}-gradient-${status}`;
            const patternId = `${ganttIdPrefix}-pattern-${status}`;
            return (<g key={`${ganttIdPrefix}-defs-${status}`}>
              <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor={color} stopOpacity={0.85}/>
                <stop offset="100%" stopColor={color} stopOpacity={0.55}/>
              </linearGradient>
              <pattern id={patternId} width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                <rect width="6" height="6" fill={`${color}2E`}/>
                <line x1="0" y1="0" x2="0" y2="6" stroke={`${color}70`} strokeWidth="1"/>
              </pattern>
            </g>);
        })}
      </defs>
    );
}
